
/**
 * @fileOverview ModalLaunchController Module File.
 *
 * This file is used to handle the showing/hiding of content. It is configurable to support the two main contexts in
 * which it is used.  The showing and hiding of the fly-out nav in mobile, and the showing and hiding of the content
 * drawers.
 *
 * @author jmaki
 * @version 1.0
 * Last Modified: 7/30/2014
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ModalLaunchController',['require','lib/Util','jquery','views/BackdropView','GlobalEventDispatcher','GlobalResizeListener'],function (require) {
        var Util = require('lib/Util');
        var $ = require('jquery');
        var BackdropView = require('views/BackdropView');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');

        /**
         * @name ModalLaunchController
         * @class ModalLaunchController binds the show/hide function to a  DOM element, identifies the target
         * @param element {Element} the domElement to bind to the event
         * @param app {object} the application instance
         * @constructor
         *
         * @since 1.0
         */
        var ModalLaunchController = function (element) {

            this.$element = $(element);
            this.$trigger = this.$element;

            // Check to see if trigger has data-options 'trigger' set the reversedTrigger
            if (this.$element.data('options').trigger === undefined){
                $debug('Trigges has data-options', 'ModalLaunchController');
                this.reversedTrigger = false;
            } else {
                $debug('Found child with js-triggerLink. Length:  ' + this.$trigger.children('js-triggerLink').length, 'ModalLaunchController');
                this.reversedTrigger = true;
            }

            this.settings = undefined; // used to store the settings
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application
            this.globalResizeListener = GlobalResizeListener.getResizeListener(); // A reference to the global resize listener.
            this.backdropView = undefined; // if ModalLaunchController needs to activate/deactivate a backdrop
            this.isLocked = false;   // used to lock the controller, until the completion of an open or close event
            this.isEnabled = false;  // used to track if the object is enabled
            this.isOpen = false;     // used to track if the object is currently in its 'open' state
            this.geoLocator = '.rX-XX-geoLocator';	// used to check if modal is a geo locator modal 
            $debug('ModalLaunchController loaded - use ?debug=ModalLaunchController for messages');
            $debug('**** ModalLaunchController Set Up Started **** ', 'ModalLaunchController');
            this.init();
        };

        /**
         * Initializes the Controller
         *
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.init = function () {
            this.isEnabled = false;

            if (this.$trigger.length > 0) {
                return this.setOptions()
                    .createChildren()
                    .setupHandlers()
                    .enable();
            }
        };

        /**
         * Merges options from the DOM element with defaults
         * @return {ModalLaunchController}
         */
        ModalLaunchController.prototype.setOptions = function () {
            var options = this.$trigger.data().options;
            /* ToDo - Task: make some of the default class names more generic (isActive etc) */
            var defaults = {
                target: '#js-inlineModal',
                targetActiveClass: 'MMM--isActive',
                triggerActiveClass: 'MMM--navItemList-hasSubNav_isOpen',
                closeOn: ['contentOpen', 'contextChange', 'contentClose'],
                openEvent: 'modalOpen',
                closeEvent: undefined,
                enabledMobile: false,
                backdropActiveClass: 'MMM--isActive',
                backdropContext: ['mobile', 'tablet', 'desktop'],
                disableOn: [],
                enableOn: ['largeContext', 'luxuryContext', 'smallContext', 'mediumContext'],
                modalWidth: '90%',
                modalTop: '70px',
                scrollToOnOpen: undefined,
                trigger: null,
                modalTheme: 'Default Theme',
                lastFocusedElement: ''
            };
            this.settings = $.extend({}, defaults, options);  //merge defaults with data-options object
            $debug('\n\n******** ModalLaunchController Options **********', 'ModalLaunchController');
            $debug('     HTML data-options Settings: ' + $printObj(options),'ModalLaunchController');
            $debug('     Default Settings: ' + $printObj(defaults),'ModalLaunchController');
            $debug('     Combined Settings: ' + $printObj(this.settings),'ModalLaunchController');
            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @returns {SampleView}
         */
        ModalLaunchController.prototype.createChildren = function () {
            // if the trigger has data-target, use that as the target, otherwise leave it undefined

            // Check to see if flag reversedTrigger is set
            if(this.reversedTrigger === true){
                //setting the target
                this.$target = this.$element;
                //setting trigger, if trigger has data-trigger, use that as the target
                this.$trigger = $(this.settings.trigger);
                $debug('in the reversed child, ' + this.settings.trigger + this.$trigger.length, 'ModalLaunchController');
            } else {
                //otherwise if the trigger has data-target, use that as the target
                this.$target = $(this.settings.target);
            }

            var backdropOptions = {
                backdropActiveClass: this.settings.backdropActiveClass,
                bodyShift: false
            };

            this.backdropView = new BackdropView(this.closeCallback.bind(this), backdropOptions);

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.setupHandlers = function () {
            var self = this,
                i,
                obj;

            // Add accessibility and ARIA labels
            $('.js-modalTrigger').attr('aria-haspopup', 'dialog');
            $('.js-modalTrigger').attr('role', 'dialog');
            $('.js-modalTrigger').attr('aria-modal', 'true');
            $('a[type="submit"]').attr('role', 'button');
            $('a[type="submit"]').attr('tabindex', '0');
            /*
               In this part it will check if the aria-label comes from the AT
               if not, it will check if the text next to the icon exists and will place it as an aria-label
               and if not it will check the SETTINGS file in checkAriaLabel function
            */
            var $closeLink = $('.js-modalTrigger').find('.js-closeLink');
            var closeLinkTag = $closeLink.attr('aria-label');
            if(closeLinkTag == '' || closeLinkTag == undefined){
                var closeLinkText = $closeLink.text().trim();
                closeLinkText == '' ? checkAriaLabel($closeLink,'txt_close') : $closeLink.attr('aria-label',closeLinkText);
            }

            //subscribing to the listner
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.resizeCheck.bind(this));

            // subscribe to the events that should cause the close function to run
            for (i = 0; i < this.settings.closeOn.length; i++) {
                obj = this.settings.closeOn[i];
                if (obj === 'contextChange') {
                    self.eventDispatcher.subscribe(obj, this.closeContent.bind(self, 0));
                } else if (obj === 'contentOpen') {
                    self.eventDispatcher.subscribe(obj, this.closeContent.bind(self, 0));
                } else {
                    self.eventDispatcher.subscribe(obj, this.closeContent.bind(self));
                }
            }

            //ToDo Create 'contextualizer' class that handles this, add the class to NavigationSubMenu as well
            // subscribe to the events that should cause the the function to enable
            for (i = 0; i < this.settings.enableOn.length; i++) {
                obj = this.settings.enableOn[i];
                self.eventDispatcher.subscribe(obj, this.enable.bind(self));
            }
            // subscribe to the events that should cause the the function to disable
            for (i = 0; i < this.settings.disableOn.length; i++) {
                obj = this.settings.disableOn[i];
                self.eventDispatcher.subscribe(obj, this.disable.bind(self));
            }

            // the event is bound to the anchor in the tab, bound to touchend to prevent swiping from triggering tabs
            // Check first to se if the flag reversed Target is false check only for js-triggerLink
            if (this.reversedTrigger === false){
                this.$trigger.on('click', '.js-triggerLink', function (event) {
                    //needed for IE Support
                    if (event.preventDefault) {
                        event.preventDefault();
                    } else {
                        event.returnValue = false;
                    }

                    if (self.isEnabled === false) {
                        return;
                    }
                    self.contentToggle();
                });
            }
            // if flag reversedTrigger is set to true click on the element itself
            else {
                this.$trigger.on('click', function (event) {
                    //needed for IE Support
                    if (event.preventDefault) {
                        event.preventDefault();
                    } else {
                        event.returnValue = false;
                    }

                    if (self.isEnabled === false) {
                        return;
                    }
                    self.contentToggle();
                });
            }


            $('.js-closeLink').on('click', function (event) {
                //needed for IE Support
                if (event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }

                self.eventDispatcher.publish('contentClose');
            });

            //close the modal on key pressed 'esc'
            $(document).on('keydown', function (event) {
                 var code = event.which;
                //close on esc or tab
                if (code === 27){
                    if (self.isOpen === true){
                        self.eventDispatcher.publish('contentClose');
                    }
                }
             });

            self.ariaFormTags();
            return this;
        };

        /**
         * Sets the isEnabled flag to true
         * Exits early if it is already enabled
         *
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            } else {
                this.isEnabled = true;
                $debug('ModalLaunchController.js loaded/enabled');
            }
            return this;
        };

        /**
         * Sets the isEnabled flag to false
         * Exits early if it is already disabled
         *
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            } else {
                this.isEnabled = false;
            }
            return this;
        };

        /**
         * Adds ARIA tags and properties to the pop-up form
         * Adds unique id for form
         * 
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.ariaFormTags = function () {
            var self = this;
            $('.js-modalTrigger').each(function() { 
                // Add a unique ID for forms
                var uniqueModal = 'js-modal_' + Math.floor(Math.random() * 1000000000);
                $(this).attr('id', uniqueModal);
                $(this).attr('aria-labelledby', uniqueModal);
                $(this).attr('aria-hidden', 'true');
            });
            return self;
        }

        /**
         * Disables the module, can be extended to remove handlers if needed
         *
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.destroy = function () {
            this.disable();
            return this;
        };

        // a callback passed to the backdrop
        ModalLaunchController.prototype.closeCallback = function () {
            if (this.isLocked) {
                return;
            }
            this.closeContent();
        };

        /* ToDo - Task: look into ways to eliminate repeated code closeDrawer/openDrawer */
        /**
         * Function that closes the drawer in question
         */
        ModalLaunchController.prototype.closeContent = function (speed) {
            var self = this,
                transition = 500;

            //if this is disabled or not open, return
            if (this.isEnabled === false || this.isOpen === false) {
                return;
            }
            if (this.settings.closeEvent !== undefined) {
                this.eventDispatcher.publish(this.settings.closeEvent);
            }
            if (this.settings.scrollToOnOpen) {
                var newPosition = this.settings.scrollToOnOpen /2;
                this.$target.animate({top:newPosition},300,function(){});
            }
            // speed is an optional parameter to force an close without transition, passed on the openEvent
            if (speed > -1) {
                transition = speed;
            }
            self.$target.slideUp(transition, function() {
                self.$target.removeClass(self.settings.targetActiveClass);
                self.$trigger.removeClass(self.settings.triggerActiveClass);
                self.$target.attr('style', '');
                self.$target.find('.MMM--modalContainer-inner').attr('style', '');
                self.$target.attr('aria-hidden', 'true');
                $('html, body').removeAttr('style');

            });

            //update the dark theme selector to revert the backdrop opacity
            $('body').find('.MMM--backdrop').removeClass('MMM--bkdrpDrkThme');

            this.settings.lastFocusedElement.focus();
            this.backdropView.hide();
            this.isOpen = false;
        };

        /**
         * Opens the target in question
         */
        ModalLaunchController.prototype.openContent = function () {
            this.settings.lastFocusedElement = document.activeElement;

            var self = this,
                $element = this.$trigger,
                screenView = $(window),
                modaltopNum = self.settings.modalTop,
                modalTheme = self.settings.modalTheme,
                modaltopNumReplace = modaltopNum.replace('%',''),
                modaltop = modaltopNumReplace,
                //modalHeight = (screenView.height() - ((screenView.height() /100) * 2)) + 'px';
                modalHeight = (screenView.height() - ( screenView.height() * (modaltop/100) *2)) + 'px',
                newPosition = self.settings.scrollToOnOpen,
                context = this.globalResizeListener.getCurrentContext();

            //disabling the scrollbar and setting the width to eliminate the flicker effect
            //$('body').innerWidth($('body').innerWidth());
            $('body').innerWidth($('body').innerWidth());
            $('html').css('overflow-y', 'scroll');
            //$('html').css('overflow-y', 'hidden');
            $('.MMM--backdrop').bind('mousewheel', function() {return false;});

            $debug('modaltop ' + modaltop, 'ModalLaunchController');
            $debug('screenview ' + screenView.height(), 'ModalLaunchController');
            $debug('modalHeight ' + modalHeight, 'ModalLaunchController');
            $debug('IN openContent() ', 'ModalLaunchController');

            
            //calling the width resize function
            self.resizeWidth();

            //trigger the open event at the end of the transition, or else immediately
            this.$target.slideDown(500, function() {
                self.$target.addClass(self.settings.targetActiveClass);
                self.eventDispatcher.publish(self.settings.openEvent);
                self.$target.find('.MMM--modalContainer-inner').css('overflow-y', 'auto');
                self.$target.find('.MMM--modalContainer-inner').css('max-height', modalHeight);
                self.$target.attr('aria-hidden', 'false');
            });

            this.backdropView.show();

            //trigger the animation for the div if scrollToOnOpen is set
            if (this.settings.scrollToOnOpen) {
                this.$target.animate({top:newPosition},300,function(){
                    if (context === 'smallContext') {
                        $debug('IN scrollToOnOpen() SMALL CONTEXT' + modalHeight, 'ModalLaunchController');
                    } else {
                        modalHeight = (screenView.height() - ( screenView.height() * (newPosition/100) *2)) + 'px';
                        $debug('IN scrollToOnOpen() NOT SMALL CONTEXT' + modalHeight, 'ModalLaunchController');
                    }
                });
            }

            // Accessibility Events for focus in pop-up form fields
            var modal = self.$target;
            var focusableElementsString = 'a[href]:not([disabled]), area[href], button:not([disabled]):not([type="hidden"]), input:not([disabled]):not([type="hidden"]), select:not([disabled]):not([type="hidden"]), textarea:not([disabled]):not([type="hidden"]), button:not([disabled]):not([type="hidden"]), iframe, object, embed, [tabindex="0"], [contenteditable]';
            var focusableElements = modal.find(focusableElementsString);
            focusableElements = Array.prototype.slice.call(focusableElements);
            var firstTabStop = focusableElements[0];
            var lastTabStop = focusableElements[focusableElements.length - 1];
            firstTabStop.focus();

            modal.keydown(function(e) {
                if (e.keyCode === 9) {
                    if (e.shiftKey) {
                        if (document.activeElement === firstTabStop) {
                            e.preventDefault();
                            lastTabStop.focus();
                        }
                    }
                    else {
                        if (document.activeElement === lastTabStop || (lastTabStop.getAttribute('href') !== null && document.activeElement.getAttribute('href') === lastTabStop.getAttribute('href')) ) {
                            e.preventDefault();
                            firstTabStop.focus();
                        }
                    }
                }

                // Close the window by pressing Esc-key 
                if (e.keyCode === 27) {
                    self.eventDispatcher.publish('contentClose');
                }
                // Close the window by pressing Enter Key
                if(e.keyCode === 13 && document.activeElement.classList.value.indexOf('js-closeLink') !== -1){
                    self.eventDispatcher.publish('contentClose');
                }
            })

            //use the dark theme selector to update the backdrop opacity
            if(modalTheme === 'Dark Theme'){
                self.$target.addClass('MMM--rW-03-DrkThmeD MMM--rW-50-DrkThmeD');
                if($(".MMM--rW-03-DrkThmeD .MMM--rW-50-DrkThmeD")[0]){
                    $('body').find('.MMM--backdrop').addClass('MMM--bkdrpDrkThme');
                }
            } else if(modalTheme === 'Light Theme'){
                self.$target.addClass('MMM--rW-50-LghtThme');
                if($(".MMM--rW-50-LghtThme")[0]){
                    $('body').find('.MMM--backdrop').addClass('MMM--bkdrpDrkThme');
                }
            } else if(modalTheme === 'Default Theme'){
                self.$target.addClass('MMM--rW-50-DefaultThme');
                if($(".MMM--rW-50-DefaultThme")[0]){
                    $('body').find('.MMM--backdrop').addClass('MMM--bkdrpDrkThme');
                }

            }

            this.isOpen = true;
        };
        /**
         * Toggles the content, locks the transition, uses DOM to check current state
         * then calls close or open where appropriate
         *
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.contentToggle = function () {
            var self = this;
            self.isLocked = true;

            window.setTimeout(function(){
                self.isLocked = false;
            }, 500);

            if (self.$trigger.hasClass(self.settings.triggerActiveClass)) {
                $debug('IN openContent() has Class', 'ModalLaunchController');
                self.closeContent();
            } else {
                $debug('IN openContent() has no Class', 'ModalLaunchController');
                self.openContent();
            }
            return this;
        };

        ModalLaunchController.prototype.resizeCheck = function () {
            var self = this;
            self.resizeWidth();
        };

        /**
         * Toggles the content width and top position with the window resize
         *
         * @returns {ModalLaunchController}
         * @since 1.0
         */
        ModalLaunchController.prototype.resizeWidth = function () {
            var self = this,
                modalwidth = self.settings.modalWidth,
                modalTop = self.settings.modalTop,
                context = this.globalResizeListener.getCurrentContext();
            
            $debug('Layout Change Fired ' + context, 'ModalLaunchController');
            
            if (self.$element.parents(self.geoLocator).length) {
            
                if (context === 'smallContext') {
                        self.$target.css('width', '91%');
                        self.$target.css('top', '70px');
                                    
                } else if (context === 'mediumContext') {
                        self.$target.css('width', '70%');
                        self.$target.css('top', '70px');
                
                } else if (context === 'largeContext') {
                        self.$target.css('width', '50%');
                        self.$target.css('top', '175px');
                
                } else if (context === 'luxuryContext') {
                        self.$target.css('width', '50%');
                        self.$target.css('top', '175px');
                }
                  
            } else {
            
                if (context === 'smallContext') {
                    self.$target.css('width', '90%');
                    self.$target.css('top', '50px');
                    $debug('IN CONTEXT - ' + context, 'ModalLaunchController');

                } else {
                    $debug('WIDTH: ' +  modalwidth, 'ModalLaunchController');
                    $debug('TOP: ' +  modalTop, 'ModalLaunchController');
                    self.$target.css('width', modalwidth);
                    self.$target.css('top', modalTop);
                    self.$target.find('div.MMM--isOnMobile').find('a.MMM--galleryThumbLink').attr("disabled", "disabled"); // Disabled anchor tags only when the user is not on mobile
                }
            }
        
            return this;
        };

        /** 
		 * Function to validate if aria-label exists from values added by the AT of the element.
		 * If the value exists it will be returned, if not the function will search for the global file SETTINGS
		 * So, the required value will be the global value to search i.e: txt_close, txt_next, txt_previous
		 *  and finally will added to the $element as an aria-label
		*/
		var checkAriaLabel = function($element, requiredValue){
			var actualValue = $element.attr('aria-label');
			if(actualValue == '' || actualValue == null || actualValue === undefined ){
				SETTINGS[requiredValue] != '' ? $element.attr('aria-label', SETTINGS[requiredValue]) : $element.attr('aria-label','');
			}else{ 
				return;
			};
		};

        return ModalLaunchController;
    });

}(MMMRequire));
